import React, { createContext, useEffect, useState } from "react";
import { getItemFromStore, setItemToStore } from "../helpers/utils";

import { ComponentSpinner } from "@src/@core/components/spinner";
import useProducts from "../../layouts/components/menu/product-list-dropdown/use-product";

const ProductContext = createContext({
    productList       : [],
    selectedProduct   : null,
    setSelectedProduct: () => {},
    platformId        : null,
    setPlatformId     : () => {}
});

const ProductProvider = ({ children }) => {

    const [selectedProduct, setSelectedProduct] = useState(null);

    const { products, loading } = useProducts();

    const handleProductSelect = (product) => {
        setSelectedProduct(product);
        setItemToStore("platformId", product._id);
    };
    useEffect(() => {
        if (products?.length > 0 && !selectedProduct && !getItemFromStore("platformId")) {
            handleProductSelect(products[0]);
        }
    }, [products]);

    if (loading) return <ComponentSpinner />;

    return (
        <ProductContext.Provider
            value={{
                productList: products,
                selectedProduct,
                setSelectedProduct,
                platformId : selectedProduct?._id || getItemFromStore("platformId"),
                handleProductSelect
            }}>
            {children}
        </ProductContext.Provider>
    );
};

export { ProductContext, ProductProvider };
